module.exports = __webpack_public_path__ + "static/32884842_10216644889103552_1438302419065765888_n-34f46f76670bd836a1ee1c3ca326f25d.jpg";